import React, { useState, useEffect, useRef } from "react";
import Axios from "axios";
import { GetCookie } from "../../exports/CookieManagement";
import SwiftModal from "../CustomComponents/SwiftModal/SwiftModal";
import CustomIconButton from "../Body/CustomChartComponents/CustomIconButton/CustomIconButton";
import CustomSelect from "../Body/CustomChartComponents/CustomSelect/CustomSelect";
import Pulse from "../Loader/Pulse";
import { Cross, Add, ReceiptEdit, Refresh, ArrowRight2 } from "../CustomComponents/SwiftIcon/Icons";
import { COLOR_VARS } from "../../exports/ColorVars";
import fail from "../../assets/icons/fail.svg";
import "../../css/RaiseTicket/RaiseTicket.css";
import Badge from "../ui/badge";
import { getDeviceSize } from "../../exports/InteractiveUtils";
const REQUEST_BASE_URL = process.env.REACT_APP_REQUEST_BASE_URL;

function RaiseTicket() {
  const account_token = GetCookie("token");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    subject: "Select",
    description: "",
  });
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [ticketsLoading, setTicketsLoading] = useState(false);
  const [ticketsError, setTicketsError] = useState(null);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [conversationFiles, setConversationFiles] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [conversationLoading, setConversationLoading] = useState(false);
  const [conversationError, setConversationError] = useState("");
  const [conversations, setConversations] = useState([]);
  const [sendingMessage, setSendingMessage] = useState(false);
  const [subjectOptions, setSubjectOptions] = useState([
    {
      value: "Select Category",
      text: "Select Category",
      requiresFiles: false,
    },
  ]);
  const [subjectsLoading, setSubjectsLoading] = useState(false);
  const messagesEndRef = useRef(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear files when subject changes
    if (name === "subject") {
      setUploadedFiles([]);
    }
  };

  console.log(selectedTicket)

  const handleSubjectChange = (selectedText) => {
    // Find the option that matches the selected text
    const selectedOption = subjectOptions.find(
      (opt) => opt.text === selectedText,
    );
    const selectedValue = selectedOption ? selectedOption.value : selectedText;

    setFormData((prev) => ({
      ...prev,
      subject: selectedValue,
    }));

    setUploadedFiles([]);
  };

  const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = [];
    const errors = [];

    files.forEach((file) => {
      // Check file type
      const validTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "application/pdf",
      ];
      if (!validTypes.includes(file.type)) {
        errors.push(
          `${file.name}: Only JPG, JPEG, PNG, and PDF files are allowed`,
        );
        return;
      }

      // Check file size (5MB = 5 * 1024 * 1024 bytes)
      const maxSize = 5 * 1024 * 1024;
      if (file.size > maxSize) {
        errors.push(`${file.name}: File size must be less than 5MB`);
        return;
      }

      validFiles.push(file);
    });

    if (errors.length > 0) {
      setSubmitStatus({
        type: "error",
        message: errors.join(", "),
      });
      return;
    }

    setUploadedFiles((prev) => [...prev, ...validFiles]);
    setSubmitStatus(null);
  };

  const removeFile = (index) => {
    setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const getCurrentSubject = () => {
    return (
      subjectOptions.find((opt) => opt.value === formData.subject) ||
      subjectOptions[0]
    );
  };

  const truncateFileName = (fileName, maxLength = 30) => {
    if (!fileName) return "";
    if (fileName.length <= maxLength) return fileName;
    const firstPart = fileName.substring(0, 10);
    const lastPart = fileName.substring(fileName.length - 10);
    return firstPart + "..." + lastPart;
  };

  // Convert text to HTML preserving spaces and line breaks
  const convertToHtml = (text) => {
    if (!text) return "";
    return text.replace(/ /g, "&nbsp;").replace(/\n/g, "<br>");
  };

  // Auto-scroll to bottom of messages
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const fetchSubjects = async () => {
    try {
      setSubjectsLoading(true);

      const response = await Axios.get(`${REQUEST_BASE_URL}/support/subjects`);

      if (response.data.error === false && response.data.data) {
        const dbSubjects = response.data.data.map((subject) => ({
          value: subject.topic,
          text: subject.topic,
          requiresFiles: true,
          uploadRequired: false,
          uploadText: "Upload supporting documents (optional)",
        }));

        const newOptions = [
          {
            value: "Select Category",
            text: "Select Category",
            requiresFiles: false,
            uploadRequired: false,
            uploadText: null,
          },
          ...dbSubjects,
        ];
        setSubjectOptions(newOptions);
      }
    } catch (err) {
      console.error("Error fetching subjects:", err);
    } finally {
      setSubjectsLoading(false);
    }
  };

  const fetchTickets = async () => {
    try {
      setTicketsLoading(true);
      setTicketsError(null);

      const response = await Axios.get(
        `${REQUEST_BASE_URL}/support/tickets?token=${account_token}`,
      );

      // console.log(" API Response:", response.data);
      // console.log(" Tickets data:", response.data.data);

      if (response.data.error) {
        throw new Error(response.data.message || "Failed to fetch tickets");
      }
      const ticketsData = response.data.data || [];
      setTickets(ticketsData);
      setTicketsLoading(false);
    } catch (err) {
      console.error("Error fetching tickets:", err);
      setTicketsError(err.message || "Failed to load tickets");
      setTicketsLoading(false);
    }
  };
  useEffect(() => {
    fetchTickets();
    fetchSubjects();
  }, []);

  // Auto-scroll when conversations change
  useEffect(() => {
    if (conversations.length > 0) {
      scrollToBottom();
    }
  }, [conversations]);

  const closeModal = () => {
    setIsModalOpen(false);
    setFormData({
      subject: "Select",
      description: "",
    });
    setUploadedFiles([]);
    setSubmitStatus(null);
  };

  const openTicketDetails = (ticket) => {
    console.log("Opening ticket details for:", ticket);
    setSelectedTicket(ticket);
    setIsDetailsModalOpen(true);
    loadConversations(ticket.ticket_id);
  };

  const closeDetailsModal = () => {
    setIsDetailsModalOpen(false);
    setSelectedTicket(null);
    setConversations([]);
    setNewMessage("");
    setConversationFiles([]);
    // Refresh tickets list to reflect new sorting when modal closes
    fetchTickets();
  };

  const loadConversations = async (ticketId) => {
  setConversationLoading(true);
  setConversationError("");
  setConversations([]);

  try {
    const response = await Axios.get(
      `${REQUEST_BASE_URL}/support-tickets/conversation/${ticketId}`,
      {
        headers: {
          Authorization: `Bearer ${account_token}`,
          "Content-Type": "application/json",
        },
      }
    );

    if (response.data?.conversations) {
      setConversations(response.data.conversations);
    } else {
      setConversations([]);
    }
  } catch (error) {
    console.error(error);
    setConversationError("Failed to load conversation");
    setConversations([]);
  } finally {
    setConversationLoading(false);
  }
};

  const sendMessage = async () => {
    if (!newMessage || !selectedTicket) return;
    if (sendingMessage) return; // Prevent double sending

    try {
      setSendingMessage(true);
      let response;

      // Add message immediately to conversation for instant feedback
      const newMsg = {
        message: newMessage,
        sender: "user",
        senderName: "You",
        timestamp: new Date().toISOString(),
        fileUrls: conversationFiles.map((file) => ({
          url: URL.createObjectURL(file),
          originalName: file.name,
        })),
      };
      setConversations((prev) => [...prev, newMsg]);

      if (conversationFiles.length > 0) {
        const formData = new FormData();
        formData.append("message", newMessage);
        formData.append("sender", "user");
        formData.append("senderName", "You");

        conversationFiles.forEach((file) => {
          formData.append("files", file);
        });

        response = await Axios.post(
          `${REQUEST_BASE_URL}/support-tickets/conversation/${selectedTicket.ticket_id}/files`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${account_token}`,
              "Content-Type": "multipart/form-data",
            },
          },
        );
      } else {
        response = await Axios.post(
          `${REQUEST_BASE_URL}/support-tickets/conversation/${selectedTicket.ticket_id}`,
          {
            message: newMessage,
            sender: "user",
            senderName: "You",
          },
          {
            headers: {
              Authorization: `Bearer ${account_token}`,
              "Content-Type": "application/json",
            },
          },
        );
      }

      if (response.data.success) {
        setNewMessage("");
        setConversationFiles([]);
        // Optionally refresh conversation in background without blocking UI
        setTimeout(() => {
          loadConversations(selectedTicket.ticket_id);
        }, 100);
      }
    } catch (error) {
      console.error("Error sending message:", error);
      setConversationError("Failed to send message");
    } finally {
      setSendingMessage(false);
    }
  };

  const handleConversationFileChange = (e) => {
    const files = Array.from(e.target.files);
    setConversationFiles([...conversationFiles, ...files]);
  };

  const removeConversationFile = (index) => {
    const updatedFiles = conversationFiles.filter((_, i) => i !== index);
    setConversationFiles(updatedFiles);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.subject === "Select" || !formData.description.trim()) {
      setSubmitStatus({
        type: "error",
        message: "Please select an subject type and provide description.",
      });
      return;
    }

    const currentSubject = getCurrentSubject();
    if (currentSubject.uploadRequired && uploadedFiles.length === 0) {
      setSubmitStatus({
        type: "error",
        message: "Please upload required documents for this category.",
      });
      return;
    }

    setIsSubmitting(true);
    closeModal();
    setSubmitStatus(null);

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("subject", formData.subject);
      formDataToSend.append("category", formData.subject);
      formDataToSend.append("description", formData.description);
      formDataToSend.append("token", account_token);

      uploadedFiles.forEach((file) => {
        formDataToSend.append("files", file);
      });

      const response = await Axios.post(
        `${REQUEST_BASE_URL}/support/ticket`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response.data.error) {
        throw new Error(response.data.message || "Failed to submit ticket");
      }

      setSubmitStatus({
        type: "success",
        message: `Ticket submitted successfully! Ticket ID: ${response.data.ticketId || "N/A"}`,
      });

      setFormData({
        subject: "Select",
        description: "",
      });
      setUploadedFiles([]);

      fetchTickets();
    } catch (error) {
      setSubmitStatus({
        type: "error",
        message:
          error.response?.data?.message ||
          error.message ||
          "Failed to submit ticket. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const getStatusText = (status) => {
    switch (status?.toLowerCase()) {
      case "pending":
        return "open";
      case "accepted":
        return "Accepted";
      case "resolved":
        return "Resolved";
      case "rejected":
        return "Rejected";
      case "in_progress":
        return "In Progress";
      default:
        return status || "Unknown";
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      return new Date(dateString).toLocaleDateString("en-IN", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
    } catch {
      return "Invalid Date";
    }
  };

  const size = getDeviceSize();

  return (
    <div className="support-tickets-container">
      <div className="tickets-header">
        <div className="header-content">
          <h2>Support Tickets <span
            onClick={fetchTickets}
            // disabled={loading}
            className=''
          >
            <Refresh size={14} color={COLOR_VARS.SWIFT_COLOR4} />
          </span></h2>
          <p>Manage your support tickets and get help from our team</p>
        </div>
        <CustomIconButton
          onClick={() => setIsModalOpen(true)}
          title="Raise New Ticket"
          disabled={false}
        />
      </div>
      <div className="tickets-list-header">
        <h3>Your Support Tickets ({tickets.length})</h3>
      </div>
      <div className="tickets-content">
        {ticketsLoading || isSubmitting ? (
          <div className="loading-container">
            <Pulse />
            {/* <p>Loading your Tickets...</p> */}
          </div>
        ) : ticketsError ? (
          <div>
            <p className="error-message">{ticketsError}</p>
            <CustomIconButton
              title={ticketsError ? "Fetching..." : "Try Again"}
              onClick={fetchTickets}
            />
          </div>
        ) : tickets.length === 0 ? (
          <div className="no-tickets">
            <ReceiptEdit size={50} color={COLOR_VARS["SWIFT_COLOR4"]} />
            <h3>No Support Tickets Found</h3>
            <p>You haven't submitted any support tickets yet.</p>
            <p>Click "Raise New Ticket" to get help from our support team.</p>
          </div>
        ) : (
          <div className="tickets-list">
            {tickets.map((ticket, index) => (
              <div
                key={ticket.ticket_id || index}
                className={`ticket-card ${ticket.status === "closed" ? "closed" : ""}`}
              >
                <div className="ticket-header">
                  <div className="ticket-id">
                    <p>{ticket.subject}</p>
                    <div>{formatDate(ticket.createdAt)}</div>
                  </div>
                  <div className="ticket-status-section">

                    <div
                      onClick={() => openTicketDetails(ticket)}
                      className="ticket-status"
                    >
                      {getStatusText(ticket.status)}
                    </div>
                  </div>
                </div>

                <div className="ticket-details">
                  <div className="ticket-info">
                    <div className="ticket-files-section">
                      {/* <p>{ticket.description}</p> */}
                      <p>{ticket.lastmessage}</p>
                    </div>
                    {ticket.filesUploaded > 0 && (
                      <div>
                        {(() => {
                          // Priority: Latest conversation files > Original ticket files
                          const filesToShow =
                            ticket.latestConversationFiles &&
                              ticket.latestConversationFiles.length > 0
                              ? ticket.latestConversationFiles
                              : ticket.fileUrls;
                            return filesToShow &&
                            filesToShow.length > 0 && (
                              <div className="latest-files-preview">
                                <div className="files-preview-container">
                                  {filesToShow.map((file, index) => (
                                    <div key={index} className="message-file">
                                      <a
                                        href={file.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        {truncateFileName(
                                          file.fileName ||
                                          file.originalName ||
                                          file.url?.split("/").pop() ||
                                          `File ${index + 1}`,
                                        )}
                                      </a>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )
                        })()}
                      </div>
                    )}
                    {ticket.category && (
                      <p>
                        <strong>Category:</strong> {ticket.category}
                      </p>
                    )}
                    {ticket.updated_at &&
                      ticket.updated_at !== ticket.created_at && (
                        <p>
                          <strong>Updated:</strong>{" "}
                          {formatDate(ticket.updated_at)}
                        </p>
                      )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {isModalOpen && (
        <SwiftModal closeModal={closeModal} top="2%">
          <div className="ticket-modal-content">
            <div className="modal-header">
              <h3 className="modal-title">Raise New Ticket</h3>
              <button className="modal-close-btn" onClick={closeModal} aria-label="Close">
                <Cross size={20} color={COLOR_VARS["SWIFT_COLOR7"]} />
              </button>
            </div>

            <div className="modal-body">
              <form id="raise-ticket-form" onSubmit={handleSubmit} className="modal-form">
                <div className="form-group">
                  <label htmlFor="subject" className="form-label">
                    Subject <span className="required-asterisk">*</span>
                  </label>
                  <CustomSelect
                    options={subjectOptions.map((opt) => opt.text)}
                    defaultIndex={subjectOptions.findIndex(
                      (opt) => opt.value === formData.subject
                    )}
                    onTypeChange={handleSubjectChange}
                    title="Select Category"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="description" className="form-label">
                    Description <span className="required-asterisk">*</span>
                  </label>
                  <textarea
                    id="description"
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    placeholder="Please provide detailed information about your issue..."
                    className="form-textarea"
                    rows="5"
                    required
                  />
                </div>

                {getCurrentSubject().uploadText && (
                  <div className="form-group upload-group">
                    <label htmlFor="fileUpload" className="form-label">
                      Upload Documents{" "}
                      {getCurrentSubject().uploadRequired && (
                        <span className="required-asterisk">*</span>
                      )}
                    </label>
                    <p className="upload-info">
                      {getCurrentSubject().uploadText}
                    </p>

                    <div className="custom-file-input">
                      <input
                        type="file"
                        id="fileUpload"
                        multiple
                        accept=".jpg,.jpeg,.pdf,.png"
                        onChange={handleFileUpload}
                        className="file-input-hidden"
                      />
                      <label htmlFor="fileUpload" className="file-input-label">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}>
                          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                          <polyline points="17 8 12 3 7 8"></polyline>
                          <line x1="12" y1="3" x2="12" y2="15"></line>
                        </svg>
                        Browse Files
                      </label>
                      <span className="file-requirements">
                        JPG, PNG, PDF (Max 5MB)
                      </span>
                    </div>

                    {uploadedFiles.length > 0 && (
                      <div className="uploaded-files-container">
                        <h4 className="uploaded-files-title">Attached Files</h4>
                        <div className="uploaded-files-list">
                          {uploadedFiles.map((file, index) => (
                            <div key={index} className="file-item-chip">
                              <div className="file-item-info">
                                <span className="file-name" title={file.name}>{file.name}</span>
                                <span className="file-size">
                                  ({(file.size / 1024 / 1024).toFixed(2)} MB)
                                </span>
                              </div>
                              <button
                                type="button"
                                className="file-remove-btn"
                                onClick={() => removeFile(index)}
                              >
                                <Cross size={14} color="currentColor" />
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </form>
            </div>

            <div className="modal-footer">
              <button
                className="raise-ticket-button"
                type="submit"
                form="raise-ticket-form"
                disabled={isSubmitting}
              >
                <CustomIconButton
                  disabled={isSubmitting}
                  title={isSubmitting ? "Submitting..." : "Raise Ticket"}
                  onClick={() => { }}
                  className={size === "S" ? "btn-xl" : ""}
                />
              </button>
            </div>
          </div>
        </SwiftModal>
      )}

      {isDetailsModalOpen && selectedTicket && (
        <SwiftModal closeModal={closeDetailsModal} top="2%">
          <div className="chat-modal-container">
            {/* Chat Header */}
            <div className="chat-header">
              <div className="chat-header-info">
                <div className="ticket-id-badge">#{selectedTicket.ticket_id}</div>
                <div className="chat-header-meta">
                  <h3 className="ticket-subject">{selectedTicket.subject}</h3>
                  <span className="ticket-client">{selectedTicket.account_name}</span>
                </div>
              </div>
              <div className="modal-close" onClick={closeDetailsModal}>
                <Cross size={24} color={COLOR_VARS["SWIFT_COLOR4"]} />
              </div>
            </div>

            {/* Chat Body (Messages) */}
            <div className="chat-body">
              {sendingMessage ? (
                <div className="conversation-loading"><Pulse /></div>
              ) : conversationLoading ? (
                <div className="conversation-loading"><Pulse /></div>
              ) : conversationError ? (
                <p className="error-message">{conversationError}</p>
              ) : conversations.length === 0 ? (
                <div className="no-messages">
                  <ReceiptEdit size={40} color={COLOR_VARS["SWIFT_COLOR4"]} />
                  <p>No messages yet. Start the conversation!</p>
                </div>
              ) : (
                <>
                  {conversations.map((msg, index) => {
                    // Assuming 'admin' is the sender name/role for outgoing messages. 
                    // Adjust the condition based on your actual API response.
                    const isOutgoing = msg.sender === 'user';

                    return (
                      <div key={index} className={`chat-message-wrapper ${isOutgoing ? 'outgoing' : 'incoming'}`}>
                        <div className="chat-bubble">
                          {!isOutgoing && <span className="chat-sender-name">{msg.senderName}</span>}
                          <div
                            className="chat-text"
                            dangerouslySetInnerHTML={{ __html: convertToHtml(msg.message) }}
                          />

                          {/* File Attachments in Bubble */}
                          {msg.fileUrls && msg.fileUrls.length > 0 && (
                            <div className="chat-attachments">
                              {msg.fileUrls.map((file, fileIndex) => (
                                <a key={fileIndex} href={file.url} target="_blank" rel="noopener noreferrer" className="chat-file-link">
                                  📎 {truncateFileName(file.originalName)}
                                </a>
                              ))}
                            </div>
                          )}
                          <span className="chat-time">{formatDate(msg.timestamp)}</span>
                        </div>
                      </div>
                    );
                  })}
                  <div ref={messagesEndRef} />
                </>
              )}
            </div>

            {/* Chat Footer (Input Area) */}
            <div className="chat-footer">
              {/* Uploaded Files Preview */}
              {conversationFiles.length > 0 && (
                <div className="chat-uploads-preview">
                  {conversationFiles.map((file, index) => (
                    <div key={index} className="chat-file-badge">
                      <span>{truncateFileName(file.name)}</span>
                      <div onClick={() => removeConversationFile(index)} className="remove-file">
                        <Cross size={14} color="#ff4444" />
                      </div>
                    </div>
                  ))}
                </div>
              )}

              <div className="chat-input-row">
                <input
                  type="file"
                  multiple
                  accept=".jpg,.jpeg,.png,.gif,.pdf"
                  onChange={handleConversationFileChange}
                  style={{ display: 'none' }}
                  id="chat-file-input"
                />
                <label htmlFor="chat-file-input" className="chat-attach-btn">
                  <Add size={24} color={COLOR_VARS["SWIFT_COLOR4"]} />
                </label>

                <textarea
                  value={newMessage}
                  onChange={(e) => setNewMessage(e.target.value)}
                  // onKeyDown={handleKeyDown}
                  placeholder="Type a message... (Press Enter to send)"
                  className="chat-textarea"
                  rows="1"
                />

                <button
                  className="chat-send-btn"
                  onClick={sendMessage}
                  disabled={(!newMessage.trim() && conversationFiles.length === 0) || sendingMessage}
                >
                  <ArrowRight2 size={24} color={(!newMessage.trim() && conversationFiles.length === 0) ? '#ccc' : COLOR_VARS["SWIFT_COLOR4"]} />
                </button>
              </div>
            </div>
          </div>
        </SwiftModal>
      )}
    </div>
  );
}

export default RaiseTicket;
